<template>

    <v-data-table :headers="headers" :items="items" :items-per-page="-1" hide-default-footer>

        <template v-slot:item.quote="{item}">
            <div class="d-flex flex-row ">
                <built-value v-if="item.built" :built="item.built" :type="item.itemType" class="mr-2"/>
                <v-checkbox
                :disabled="!isModifiable"
                v-model="item.quote"
                :hide-details="true"
                v-on:change="quoteItem(item)"
                class="mt-0"
                ></v-checkbox>
            </div>
        </template>

        <template #[`item.sst`]="{item}">
            <v-icon :color="[item.sst?'green':'red', 'lighten-3'].join(' ')">{{item.sst?'mdi-check-circle':'mdi-close-circle'}}</v-icon>
        </template>

        <template #[`item.stamping`]="{item}">
            <v-icon :color="[item.stamping?'green':'red', 'lighten-3'].join(' ')">{{item.stamping?'mdi-check-circle':'mdi-close-circle'}}</v-icon>
        </template>

        <template #[`item.paintfill`]="{item}">
            <v-icon :color="[item.paintfill?'green':'red', 'lighten-3'].join(' ')">{{item.paintfill?'mdi-check-circle':'mdi-close-circle'}}</v-icon>
        </template>

        <template #[`item.head`]="{item}">
            <b>{{ item.headProduct.name }}</b><br>
            <span v-if="item.headSetting">Settings: {{ item.headSetting }}<br></span>
            <span v-if="item.headSetting2">Settings 2: {{ item.headSetting2 }}<br></span>
            <span v-if="item.headLoft">Loft: {{ item.headLoft }}<br></span>
            <span v-if="item.headLie">Lie: {{ item.headLie }}<br></span>
            <span v-if="item.headStamp">Stamping: {{ item.headStamp }}</span>
            <span v-if="item.headPaintfill">Paintfill: {{ item.headPaintfill }}<br></span>
        </template>

        <template #[`item.shaft`]="{item}">
            <template v-if="!item.headOnly">
                <b>{{ item.shaftProduct.name }}</b><br>
                <span v-if="item.shaftLength">Length: {{ item.shaftLength }}<br></span>
                <span v-if="item.shaftCpm">CPM: {{ item.shaftCpm }}<br></span>
                <span v-if="item.shaftSW">SW: {{ item.shaftSW }}<br></span>
                <span v-if="item.shaftPaintfill">Paintfill: {{ item.shaftPaintfill }}<br></span>
            </template>
        </template>

        <template #[`item.grip`]="{item}">
            <template v-if="!item.headOnly">
                <b>{{ item.gripProduct.name }}</b><br>
                <span v-if="item.gripExtraWraps">Extra Wraps: {{ item.gripExtraWraps }}<br></span>
                <span v-if="item.gripLogo">Logo: {{ item.gripLogo }}</span>
            </template>
        </template>

        <template #[`item.actions`]="{item}">
            <v-btn v-if="isModifiable" outlined small @click="$emit('edit', item)" class="mr-2">
            edit
            </v-btn>
            <v-btn v-if="isModifiable" outlined small @click="doDeleteItem(item)" color="error" class="mr-2">
            delete
            </v-btn>
        </template>

    </v-data-table>
</template>

<script>
import { mapActions } from 'vuex';
import BuiltValue from './built/BuiltValue.vue';
export default {
    components:{
        BuiltValue
    },
    props: {
        items: {
            type: Array,
            required:true
        },
        isModifiable: {
            type: Boolean,
            default: () => true
        },
        headers: {
            type: Array,
            default: () => ([
                { text: "Quote", value: "quote", sortable: false },
                { text: "Quantity", value: "quantity" },
                { text: "SST Pure", value: "sst", sortable: false },
                { text: "Head", value: "head" },
                { text: "Shaft", value: "shaft" },
                { text: "Grip", value: "grip" },
                { text: "Actions", value: "actions"},
            ])
        }
    },
    data: () => ({
        loading: false
    }),
    
    methods: {
        ...mapActions('prescriptions', ['toggleQuote', 'deleteItem']),
        quoteItem(item) {
            this.loading = true
            this.toggleQuote(item)
                .finally(() => {
                    this.loading = false;
                    this.$emit("update");
                });
        },
        doDeleteItem(item) {
            this.loading = true
            this.deleteItem(item)
                .finally(() => {
                    this.loading = false;
                    this.$emit("update");
                });
        }
    }
}
</script>

<style>
td.vertical-top
{
    vertical-align: top;
    padding-top: 5px !important;
}
</style>